export default __webpack_public_path__ + "static/media/ImpactMarket.f5f27000.png";